const Contenido2 = () => {
    return (
        <>
            <h1>Contenido 2</h1>
            <h3>Segundo Apartado</h3>
        </>
    )
}

export default Contenido2